import { Component, Input, input, output } from '@angular/core';
import { IonButton, IonIcon } from '@ionic/angular/standalone';
import { IMAGE_SRC } from 'src/app/components/shared/shared-constants';
import { CONSTS } from '../add-new-scan.constants';

@Component({
  selector: 'app-file-upload-button',
  imports: [IonButton, IonIcon],
  templateUrl: './file-upload-button.component.html',
  styleUrl: './file-upload-button.component.scss',
})
export class FileUploadButtonComponent {
  @Input() disabled: boolean = false;
  readonly CONSTS = CONSTS;
  readonly SRC = IMAGE_SRC;
  uploadClick = output();
}
